import React, { createContext, useContext, useState, useEffect } from 'react';
import { login as apiLogin, getMe } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const stored = localStorage.getItem('user');
    if (token && stored) {
      setUser(JSON.parse(stored));
      getMe().then(r => {
        setUser(r.data.user);
        localStorage.setItem('user', JSON.stringify(r.data.user));
      }).catch(() => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setUser(null);
      }).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const { data } = await apiLogin(email, password);
    localStorage.setItem('token', data.token);
    localStorage.setItem('user', JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{
      user, login, logout, loading,
      // Legacy
      isPlatformAdmin:   user?.role === 'PLATFORM_ADMIN',
      isAdmin:   user?.role === 'ADMIN',
      isFinance: user?.role === 'FINANCE',
      isBuyer:   user?.role === 'BUYER',
      isSeller:  user?.role === 'SELLER',
      // New roles
      isSalesExec:      user?.role === 'SALES_EXECUTIVE',
      isSalesOfficer:   user?.role === 'SALES_OFFICER',
      isAccountsOfficer:user?.role === 'ACCOUNTS_OFFICER',
      isHeadAccounts:   user?.role === 'HEAD_ACCOUNTS',
      // Permission helpers (union of old + new)
      canCreate:         ['ADMIN','SELLER','SALES_EXECUTIVE','SALES_OFFICER'].includes(user?.role),
      canApproveOrder:   ['ADMIN','SELLER','SALES_OFFICER','HEAD_ACCOUNTS'].includes(user?.role),
      canApproveInvoice: ['ADMIN','SELLER','SALES_OFFICER','FINANCE','HEAD_ACCOUNTS'].includes(user?.role),
      canRaiseInvoice:   ['ADMIN','SELLER','SALES_EXECUTIVE','SALES_OFFICER'].includes(user?.role),
      canPostJournal:    ['ADMIN','FINANCE','ACCOUNTS_OFFICER','HEAD_ACCOUNTS'].includes(user?.role),
      canConfirmTrigger: ['ADMIN','SELLER','SALES_EXECUTIVE','SALES_OFFICER'].includes(user?.role),
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
